import { render, staticRenderFns } from "./ownerDetailRoom.vue?vue&type=template&id=47850bb5&scoped=true"
import script from "./ownerDetailRoom.vue?vue&type=script&lang=js"
export * from "./ownerDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailRoom.vue?vue&type=style&index=0&id=47850bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47850bb5",
  null
  
)

export default component.exports